import React from 'react'

import { HorizontalForm, CollapsibleInputGroup } from 'alto-react-components/lib/components'

import { inputFor, validateInput } from './input'

export default class SmartInputs extends React.Component
  constructor: (props) ->
    super(props)

    switch props.action
      when 'create'
        @state =
          values:      props.defaultValues,
          validStates: {},
      when 'update'
        @state =
          values:      _.cloneDeep(props.record),
          validStates: {},
      else
        throw new Error("invalid form action: #{props.action}")

    @props.onChange(@state.values)

  componentWillMount: ->
    @validateAll()

  render: ->
    @props.specs.specs.map(@inputOrGroupFor.bind(@))

  inputOrGroupFor: (spec) ->
    if spec.property
      @formGroupFor(spec)
    else if spec.group
      <CollapsibleInputGroup title={spec.label} collapsed={spec.collapsed} key={spec.name}>
        {spec.inputs.map(@formGroupFor.bind(@))}
      </CollapsibleInputGroup>
    else
      throw new Error('invalid input/group spec: ' + JSON.stringify(spec))

  formGroupFor: (spec) ->
    value  = _.get(@state.values, spec.property)
    errors = @props.errors?[spec.property]
    valid  = @state.validStates[spec.property] and not errors
    help   =
      if errors then errors.map((error, i) -> <p key={i}>{error}</p>)
      else spec.help

    <HorizontalForm.Group label={spec.label} id={"#{spec.property}"} key={spec.property}
                          valid={valid} help={help}>
      {inputFor(spec, value, @props.record, @handleChange.bind(@))}
    </HorizontalForm.Group>

  handleChange: (property, value) ->
    @setState(values: _.set(_.cloneDeep(@state.values), property, value), =>
      @props.onChange(@state.values)
      @validateProperty(property, value))

  validateAll: ->
    pairs = @props.specs.allInputs().map (spec) =>
      [spec.property, validateInput(spec, _.get(@state.values, spec.property), @props.record)]

    @setState(validStates: _.fromPairs(pairs), => @props.onValidChange(@isAllValid()))

  validateProperty: (property, value) ->
    valid = validateInput(@props.specs.specFor(property), value, @props.record)

    @setState(validStates: _.assign({}, @state.validStates, "#{property}": valid), =>
      @props.onValidChange(@isAllValid()))

  isAllValid: ->
    _.every(_.values(@state.validStates))
